import { put, takeLatest, call, all } from 'redux-saga/effects';
import axios from 'axios';
import { API_URL } from "../../../config";
import { SESSION_EXPIRED } from "../../../_utils/constants/Auth";
import {
  PROPERTY_REQUEST,
  PROPERTY_SUCCESS,
  PROPERTY_FAILED,
  PROPERTY_CREATE,
  PROPERTY_CREATE_SUCCESS,
  PROPERTY_CREATE_FAILED,
  PROPERTY_DELETE,
  PROPERTY_DELETE_SUCCESS,
  PROPERTY_DELETE_FAILED,
  PROPERTY_EDIT,
  PROPERTY_EDIT_SUCCESS,
  PROPERTY_EDIT_FAILED,
} from "../../../_utils/constants/ProductCatalog";


/*****
 * Property Actions
 */

function* fetchProperty({ token }) {
  try {
    const response = yield call(axios.get, `${API_URL}/Product/api/Property/GetProperty`, { headers: { Authorization: `Bearer ${token}` } });
    yield put({ type: PROPERTY_SUCCESS, payload: response.data });
  } catch (error) {
    if (error && error.response && error.response.status && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({ type: PROPERTY_FAILED, payload: error.response });
    }
  }
}

function* createProperty(action) {
  try {
    const response = yield call(
      axios.post,
      `${API_URL}/Product/api/Property/CreateProperty`,
      action.payload.data, {
      headers: {
        Authorization: `Bearer ${action.payload.token}`
      },
    }
    );
    yield put({
      type: PROPERTY_CREATE_SUCCESS,
      payload: response.data
    });
  }
  catch (error) {
    if (error && error.response && error.response.status && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({
        type: PROPERTY_CREATE_FAILED,
        payload: error.response
      });
    }
  }
}
function* editProperty(action) {
  try {
    const response = yield call(
      axios.post,
      `${API_URL}/Product/api/Property/UpdateProperty`,
      action.payload.data, {
      headers: {
        Authorization: `Bearer ${action.payload.token}`
      },
    }
    );
    yield put({
      type: PROPERTY_EDIT_SUCCESS,
      payload: response.data
    });
  }
  catch (error) {
    if (error && error.response && error.response.status && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({
        type: PROPERTY_EDIT_FAILED,
        payload: error.response
      });
    }
  }
}
function* deleteProperty(action) {
  try {
    const response = yield call(
      axios.delete,
      `${API_URL}/Product/api/Property/RemoveProperty?PropertyId=${encodeURIComponent(action.payload.PropertyId)}`, {
      headers: {
        Authorization: `Bearer ${action.payload.token}`
      }
    },
    );
    yield put({
      type: PROPERTY_DELETE_SUCCESS,
      payload: response.data
    });
  }
  catch (error) {
    if (error && error.response && error.response.status && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({
        type: PROPERTY_DELETE_FAILED,
        payload: error.response
      });
    }
  }
}



export default function* rootPropertyList() {
  yield all([
    takeLatest(PROPERTY_REQUEST, fetchProperty),
    takeLatest(PROPERTY_CREATE, createProperty),
    takeLatest(PROPERTY_DELETE, deleteProperty),
    takeLatest(PROPERTY_EDIT, editProperty),
  ]);
}